<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش دسته بندی ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/setting/category/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات دسته بندی ها</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/setting/category/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت دسته بندی جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="categories.data"
                :items-per-page="10"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.icon`]="{ item }">
                <v-img :src="item.icon" width="70" height="60" class="mr-16"></v-img>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="$router.push('/setting/category/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="categories.current_page"
                :length="categories.last_page"
                circle
                @input="getCategories"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "CategoryIndexView",
  data() {
    return {
      loading: true,
      categories: {
        current_page: 1
      },
      headers: [
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'لیبل', value: 'label', align: 'center'},
        {text: 'نوع', value: 'type', align: 'center'},
        {text: 'کاور', value: 'icon', align: 'center'},
        {text: 'توضیحات', value: 'description', align: 'center'},
        {text: 'کنترل', value: 'operation', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      let url = 'category/index?page=' + this.categories.current_page ?? 1
      window.axios.get(url).then((res) => {
        this.categories = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(categoryId) {
      window.axios.delete('category/delete/' + categoryId).then(() => {
        this.getCategories()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }

  }
}
</script>

<style scoped>

</style>